<div class="container-fluid padMob webViewBack padZero" style="padding-left: 10px; padding-right: 10px;">
    <div class="row HeadDiv bg mobView">
        <!-- Header --> 
        <div class="col-md-12 col-12 col-sm-12 bgWhite padHeder divHeader"  style="padding-bottom: 10px;">
            <span style="font-size: 22px; margin-right: 10px; display: inline-block; cursor: pointer;" class="mobView" (click)="goBack();"><i class="fa fa-chevron-left"></i></span>
            <h4 style="display: inline-block;">Product Byproducts</h4>    
            <span style="float: right;">
                <span class="label" (click)="openItemSelect(selectItem)" 
                    style="border-radius: 50%; cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                </span>
                <div class="webView">
                    <span style="border-radius: 50%; cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; display: inline !important; margin-left: 10px; display: none !important;" class="webView closeMdl" (click)="goBack();">
                        <i class="zmdi zmdi-close"></i>
                    </span>
                </div>
                
            </span>
        </div>

        <!-- Body -->
        <div class="col-md-12 col-12 col-sm-12 headerPadding DivPad">            
            <!-- Product Name -->
            <div class="col-md-12 col-12 col-sm-12 bgWhite" style="padding-bottom: 10px; padding-left: 15px;">
                <div class="col-md-12 col-12 col-sm-12" style="font-size: 22px; padding-left: 0px;">
                    <span style="color: #E88421;">
                        <i class="zmdi zmdi-widgets"></i> {{prductData.productName}}
                    </span>  
                </div>
            </div>           

            <!-- Item List -->
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <div *ngIf="prductData.byproduct.length > 0">
                    <div class="bgWhite pad15 marginTp" *ngFor="let P of prductData.byproduct; let i = index" style="padding-right: 15px;">                    
                        <div class="col-md-12 col-12 col-sm-12 pad0">                            
                            <div>
                                <div class="col-md-7 col-7 col-sm-7 pad0 inLneBlk">
                                    <span class="font14">{{P.productName}}</span>
                                </div>
                                <div class="col-md-5 col-5 col-sm-5 pad0 inLneBlk txtRight">
                                    <span class="lableBtnGray" style="padding: 2px 7px 2px; border-radius: 10px;"><i class="fa fa-trash-o" (click)="removeByproduct(i)"></i></span>
                                </div>
                            </div>
                            <div>
                                <div class="col-md-7 col-7 col-sm-7 pad0 inLneBlk">
                                    <span class="font14" style="margin-bottom: 0px;color: #777;">{{P.productCode}}</span>
                                </div>
                                <div class="col-md-5 col-5 col-sm-5 pad0 inLneBlk" style="text-align: right;">
                                    <span class="inLneBlk" style="width: min-content;"> <input type="text" id="txtItem"
                                            class="form-control " tabindex="1"  [(ngModel)]="P.ReqdQty"  placeholder="Qty" title="Item Name" captalize-first
                                            style=" height: 20px;padding: 15px; width: 80px; background: inherit; text-align: right;"
                                            maxlength="50" />
                                    </span>
                                    <span class="inLneBlk font14"> {{P.Unit}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bgWhite" style="padding-top: 15px; padding-right: 15px;"  *ngIf="prductData.byproduct.length == 0">
                    <div class="nrf" (click)="openItemSelect(selectItem);" style="margin-left: 15px;">
                        Click here to add a byproduct to your product.
                    </div>
                </div>

                <!-- Stage Save -->
                <div class="col-md-12 col-12 col-sm-12 bgWhite" style="padding-top: 10px;">
                    <div class="btn btn-green" (click)="fn_saveByproduct();">
                        <i class="zmdi zmdi-check"></i> Save
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row HeadDiv webView" style="width: 100%;">
        <!-- Body -->
        <div class="col-md-12 col-12 col-sm-12" style="padding: 0px;">            
            <!-- Item List -->
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <div style="color: #4caf50; font-size: 19px;">
                    <span>Product Byproducts ({{prductData.byproduct.length}})</span>
                    <span style="float: right; font-size: 20px; cursor: pointer;" *ngIf="isEdit" (click)="openItemSelect(selectItem)"><i class="zmdi zmdi-plus"></i></span>
                    <span style="float: right; font-size: 15px; cursor: pointer; margin-right: 5px;" *ngIf="!isEdit" (click)="isEdit = true"><i class="fa fa-pencil"></i></span>
                    <!-- <span style="float: right; font-size: 20px; cursor: pointer;" (click)="fn_OpenBOM();" class="mobView"><i class="zmdi zmdi-plus"></i></span> -->
                </div>
                <div *ngIf="prductData.byproduct.length > 0">
                    <div class="marginTp" *ngFor="let P of prductData.byproduct; let i = index">                    
                        <div class="col-md-12 col-12 col-sm-12 pad0">                            
                            <div>
                                <div class="col-md-7 col-7 col-sm-7 pad0 inLneBlk">
                                    <span class="font14">{{P.productName}}</span>
                                </div>
                                <div class="col-md-5 col-5 col-sm-5 pad0 inLneBlk txtRight">
                                    <span class="inLneBlk" style="width: min-content;"> 
                                        <span *ngIf="isEdit">
                                            <input type="text" id="txtItem"
                                            class="form-control " tabindex="1"  [(ngModel)]="P.ReqdQty"  placeholder="Qty" title="Item Name" captalize-first
                                            style=" height: 20px;padding: 15px; width: 80px; background: inherit; text-align: right;"
                                            maxlength="50" />
                                        </span>
                                        <span *ngIf="!isEdit" style="margin-right: 5px;">
                                            {{P.ReqdQty}}
                                        </span>
                                    </span>
                                    <span class="inLneBlk font14" style="margin-right: 5px;"> {{P.Unit}}</span>
                                    <span class="lableBtnGray" style="padding: 2px 7px 2px; border-radius: 10px;" *ngIf="isEdit"><i class="fa fa-trash-o" (click)="removeByproduct(i)"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Stage Save -->
                <div class="col-md-12 col-12 col-sm-12" style="padding-top: 10px; padding-left: 0px;" *ngIf="isEdit">
                    <div class="btn btn-green" style="line-height: 30px;" (click)="fn_saveByproduct();">
                        <i class="zmdi zmdi-check"></i> Save
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="prductData.byproduct.length == 0">
            <div class="nrf" (click)="openItemSelect(selectItem);" style="margin-top: 15px; font-size: 14px;">
                Click here to add a byproduct to your product.
            </div>
        </div>
    </div>
</div>

<!-- Item Modal -->
<ng-template #selectItem let-modal>
    <button id="closeModalButton" data-toggle="modal" [hidden]="true"       
    data-target="#myModal" class="btn btn-default" (click)="closeModal()">Close</button>
    <app-multiple-select-item></app-multiple-select-item>
</ng-template>